const CryptoJS = require('crypto-js');

export const encryptPassword = (password:any,encryptionKey:any) => {
    try {
        // Generate a random IV
        const iv = CryptoJS?.lib?.WordArray.random(16); // Generate 16 bytes (128 bits) IV
  
        // Encrypt the password with the encryption key and IV
        const encrypted = CryptoJS?.AES?.encrypt(password, CryptoJS.enc.Base64.parse(encryptionKey), {
            iv: iv,
            padding: CryptoJS?.pad?.Pkcs7,
            mode: CryptoJS?.mode?.CBC,
        });
  
        // Prepend IV to encrypted data
        const encryptedWithIv = iv?.concat(encrypted.ciphertext);
        
        return CryptoJS?.enc?.Base64?.stringify(encryptedWithIv); // Return Base64-encoded string
    } catch (error) {
       
        throw new Error("Encryption failed");
    }
  };

  